export default "__VITE_ASSET__BPWpjAoB__"